import "./topNav.css";

import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Drawer, IconButton } from "@mui/material";
import { Menu as MenuIcon, Close as CloseIcon } from "@mui/icons-material";

import { NAV_LINKS, PAGE_ROUTES, CONTACT_DETAILS } from "../../utils/stateTypes";
import { useScrolledPast } from "../general/hooks";

const TopNav = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const isScrolled = useScrolledPast(10);
  const { pathname } = useLocation();

  const closeMenu = () => setIsMenuOpen(false);

  //Close the mobile menu whenever the page changes
  React.useEffect(closeMenu, [pathname]);

  return (
    <header className={`top-nav ${isScrolled ? "is-scrolled" : ""}`}>
      <div className={"container"}>
        <nav
          className={"top-nav-bar"}
          aria-label={"Main"}
        >
          <Link
            to={PAGE_ROUTES.HOME}
            className={"top-nav-logo"}
          >
            <img
              src={"/images/logo.png"}
              alt={"PM Skills Foundation - home"}
              width={593}
              height={577}
            />
          </Link>

          <div className={"top-nav-links"}>
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end
                className={"top-nav-link"}
              >
                {link.label}
              </NavLink>
            ))}
          </div>

          <IconButton
            className={"top-nav-menu-btn"}
            aria-label={"Open menu"}
            aria-expanded={isMenuOpen}
            onClick={() => setIsMenuOpen(true)}
          >
            <MenuIcon />
          </IconButton>
        </nav>
      </div>

      <Drawer
        anchor={"right"}
        open={isMenuOpen}
        onClose={closeMenu}
        PaperProps={{ className: "mobile-menu" }}
      >
        <IconButton
          className={"mobile-menu-close"}
          aria-label={"Close menu"}
          onClick={closeMenu}
        >
          <CloseIcon />
        </IconButton>
        <nav
          className={"mobile-menu-links"}
          aria-label={"Mobile"}
        >
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end
              onClick={closeMenu}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>
        <div className={"mobile-menu-contact"}>
          {CONTACT_DETAILS.PHONES.map((phone) => (
            <a
              key={phone.link}
              href={phone.link}
            >
              {phone.label}
            </a>
          ))}
          <a href={`mailto:${CONTACT_DETAILS.EMAIL}`}>{CONTACT_DETAILS.EMAIL}</a>
        </div>
      </Drawer>
    </header>
  );
};

export default TopNav;
